import * as constants from './definitions.constants'

export const initialState = {
}

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_DEFINITIONS:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
